<script setup>
import { useI18n } from 'vue-i18n'
import UiStatusPill from '@/Components/UI/UiStatusPill.vue'
const { t } = useI18n()
</script>

<template>
  <UiStatusPill
    tone="ok"
    variant="soft"
    icon="check"
    :label="t('rental.show.signed')"
  />
</template>
